import { gql, useMutation } from '@apollo/client';
import { useCallback } from 'react';

interface MutationParams {
  idnumber: string;
  groupName: string;
}

type HookReturns = [
  (idnumber: string, groupName: string) => Promise<void>,
  { loading: boolean },
];

const addMutation = gql`
  mutation addToGroup($idnumber: String!, $groupName: String!) {
    addPersonToGroup(idnumber: $idnumber, groupName: $groupName) {
      darn
      groups {
        name
        description
      }
    }
  }
`;

export function useAddToGroup(): HookReturns {
  const [mutate, { loading, error }] = useMutation<unknown, MutationParams>(
    addMutation
  );

  if (error != null) throw error;

  const action = useCallback(
    async (idnumber: string, groupName: string): Promise<void> => {
      await mutate({ variables: { idnumber, groupName } });
    },
    [mutate]
  );

  return [action, { loading }];
}

const removeMutation = gql`
  mutation removeFromGroup($idnumber: String!, $groupName: String!) {
    removePersonFromGroup(idnumber: $idnumber, groupName: $groupName) {
      darn
      groups {
        name
        description
      }
    }
  }
`;

export function useRemoveFromGroup(): HookReturns {
  const [mutate, { loading, error }] = useMutation<unknown, MutationParams>(
    removeMutation
  );

  if (error != null) throw error;

  const action = useCallback(
    async (idnumber: string, groupName: string): Promise<void> => {
      await mutate({ variables: { idnumber, groupName } });
    },
    [mutate]
  );

  return [action, { loading }];
}
